export default __webpack_public_path__ + "static/media/rich-editor.e5028c55.png";